import { useState } from "react";
import { IGetTradesResponse } from "./interfaces";
import { useOrderModifyDataStore, useUnderlyingOrderModifyDataStore, useTradesStore } from "./store";

export const ActiveTrades = (props: {
  cancelOrder: (orderId: number) => void;
  ticker: string;
}) => {
  const { cancelOrder, ticker } = props;
  const [showAll, setShowAll] = useState<boolean>(false);

  const tradesStore = useTradesStore();

  const visibleTrades = tradesStore.trades.filter((trade) => {
    if (trade.orderId === 0) return false;
    if (showAll) return true;
    return trade.readable_name.toUpperCase().startsWith(ticker);
  });

  return (
    <div>
      <div className="flex items-center gap-2">
        <b>Active Trades:</b>
        <label className="flex items-center gap-1 text-sm cursor-pointer font-normal">
          <input
            type="checkbox"
            checked={showAll}
            onChange={(e) => setShowAll(e.target.checked)}
          />
          Show all
        </label>
      </div>
      {visibleTrades.length === 0 && (
        <p className="text-gray-500">Empty list</p>
      )}

      {visibleTrades.map((trade) => (
        <TradeRow
          key={trade.orderId}
          trade={trade}
          cancelOrder={cancelOrder}
        />
      ))}
    </div>
  );
};

const TradeRow = ({
  trade,
  cancelOrder,
}: {
  trade: IGetTradesResponse;
  cancelOrder: (orderId: number) => void;
}) => {
  const orderModifyDataStore = useOrderModifyDataStore();
  const underlyingOrderModifyDataStore = useUnderlyingOrderModifyDataStore();
  const [logsVisible, setLogsVisible] = useState<boolean>(false);
  const isOption = trade.readable_name.length > 6;
  const multiplier = isOption ? 100 : 1;

  function renderStatus(status: string) {
    switch (status) {
      case "Filled":
        return <span className="text-blue-500">{status}</span>;
      case "Cancelled":
        return <span className="text-red-500">{status}</span>;
      default:
        return <span className="text-yellow-500">{status}</span>;
    }
  }


  return (
    <div
      className="border p-2 mb-2"    >
      <b>
        [{trade.orderId}] {trade.action} {trade.readable_name}
      </b>
      <p >
        Order total: {trade.totalQuantity} at {trade.lmtPrice.toFixed(2)} (
        {(trade.totalQuantity * trade.lmtPrice * multiplier).toFixed(2)})
      </p>
      <p >
        Filled: {trade.filled} (at avg. {trade.avgFillPrice.toFixed(2)}, total{" "}
        {(trade.filled * trade.avgFillPrice * multiplier).toFixed(2)})
      </p>
      <div className="flex">
        <b>{renderStatus(trade.status)}</b>

        <div className="flex ml-4 gap-4">
          {trade.status !== "Filled" && trade.status !== "Cancelled" && (
            <>
              <button
                className="btn btn-primary p-1"
                onClick={() => {
                  const total = (trade.totalQuantity * trade.lmtPrice * multiplier).toFixed(2);
                  if (isOption) {
                    orderModifyDataStore.setNewOrderModifyData(
                      trade.conId.toString(),
                      trade.orderId.toString(),
                      trade.action,
                      trade.readable_name,
                      trade.lmtPrice.toFixed(2),
                      total,
                      trade.totalQuantity.toString(),
                    );
                  } else {
                    underlyingOrderModifyDataStore.setNewOrderModifyData(
                      trade.conId.toString(),
                      trade.orderId.toString(),
                      trade.action,
                      trade.readable_name,
                      trade.lmtPrice.toFixed(2),
                      total,
                      trade.totalQuantity.toString(),
                    );
                  }
                }}
              >
                Modify
              </button>
              <button
                className="btn btn-default p-1"
                onClick={() => cancelOrder(trade.orderId)}
              >
                Cancel
              </button>
            </>
          )}
        </div>
      </div>


      <div>
        <p
          className="cursor-pointer"
          onClick={() => setLogsVisible(!logsVisible)}
        >
          Trade Log:
        </p>

        <div className={`${logsVisible ? "" : "hidden"}`}>
          {trade.log.map((logEntry, index) => (
            <div key={index}>
              <p>
                [{logEntry.time}] {logEntry.status} - {logEntry.message}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
